import React from "react";

import {
  StyledCard,
  Title,
  StyledDiscountLabel,
  AfterDiscount,
  BeforeDiscount,
  CurrencyPrice,
} from "./styledPersonalPurchaseCard";

export const PriceBoxComponent = ({
  haveDiscount,
  totalprice,
  priceBeforeDiscount,
  priceAfterDiscount,
}) => {
  return (
    <>
      {!haveDiscount ? (
        <AfterDiscount className="after-discount m-3 m-md-1 flex-grow-1 text-center text-md-start">
          {totalprice?.toLocaleString()}&nbsp;
          <CurrencyPrice className="currency-price mb-2">تومان</CurrencyPrice>
        </AfterDiscount>
      ) : (
        <span className="mt-3 mt-md-1">
          <AfterDiscount className="after-discount m-1 align-text-bottom">
            {priceAfterDiscount?.toLocaleString()}&nbsp;
          </AfterDiscount>
          <BeforeDiscount className="before-discount mb-3">
            {priceBeforeDiscount?.toLocaleString()}
          </BeforeDiscount>
          <CurrencyPrice className="currency-price mb-3">
            &nbsp;تومان
          </CurrencyPrice>
        </span>
      )}
    </>
  );
};

const PersonalPurchaseCardComponent = (props) => {
  const {
    classname,
    packageImage,
    children,
    monthCount,
    showPriceAndDiscount,
    haveDiscount,
    discountPercent,
    priceAfterDiscount,
    priceBeforeDiscount,
    totalprice,
  } = props;

  return (
    <StyledCard
      className={`pb-3 d-flex flex-column align-items-center ${classname}`}
    >
      {haveDiscount && (
        <StyledDiscountLabel className="rounded-pill">
          {discountPercent}%
        </StyledDiscountLabel>
      )}
      <section className="w-auto">{packageImage}</section>
      <Title className="m-1">اشتراک {monthCount} ماهه</Title>
      {showPriceAndDiscount ? (
        <section className="m-1">
          <PriceBoxComponent
            haveDiscount={haveDiscount}
            priceAfterDiscount={priceAfterDiscount}
            priceBeforeDiscount={priceBeforeDiscount}
            totalprice={totalprice}
          />
        </section>
      ) : (
        <section className="m-2"></section>
      )}
      {children}
    </StyledCard>
  );
};
export default PersonalPurchaseCardComponent;
